import {useTranslation} from "react-i18next";
import {type ChangeEvent, useState} from "react";
import {Field} from "./Field.tsx";

const RequiredInfo = () => {
    const {t} = useTranslation('ui');
    const [phoneNum, setPhoneNum] = useState<string>("");

    const formatPhoneNumber = (value: string) => {
        const numbers = value.replace(/\D/g, "");
        if (numbers.length <= 3) return numbers;
        if (numbers.length <= 7) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
        return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
    };

    const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
        setPhoneNum(formatPhoneNumber(e.target.value))
    };

    return (
        <div className="col">
            <div className="card rounded-4 p-4 h-100 flex-column">
                <h5 className="pb-1 subheadings">{t("signUp.requiredInfo")}</h5>
                <p style={{
                    fontSize: '14px',
                    color: '#86868B',
                    padding: '5px 0 10px'
                }}>{t("signUp.passwordNotice")}</p>

                <Field
                    name="id"
                    label={t("signUp.idLabel")}
                    required
                    placeholder={t("signUp.idPlaceholder")}
                />

                <Field
                    name="email"
                    label={t("signUp.emailLabel")}
                    required
                    placeholder={t("signUp.emailPlaceholder")}
                />

                <Field
                    name="name"
                    label={t("signUp.nameLabel")}
                    required
                    placeholder={t("signUp.namePlaceholder")}
                />

                <Field
                    name="p_num"
                    label={t("signUp.phoneLabel")}
                    required
                    type="tel"
                    value={phoneNum}
                    onChange={handlePhoneChange}
                    placeholder={t("signUp.phonePlaceholder")}
                />
            </div>
        </div>
    )
}

export default RequiredInfo;